export const DEFAULT_ROW_HEIGHT = 42
export const DEFAULT_PAGE_SIZE = 25
